import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import type { PolymorphicComponentProps } from '../../utils/types';
import FilterSvg from '../svg/filter';
import type { ButtonProps } from './button';
import { ButtonHost } from './button';

export const Host = styled(ButtonHost)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${gutter(1.2)} ${gutter(2)};
`;

const Content = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin-left: ${gutter(1)};
    margin-top: 2px;
  }
`;

export const FilterButton = <C extends React.ElementType = 'button'>(
  props: PolymorphicComponentProps<C, ButtonProps>
) => {
  const { as, children, ...rest } = props;
  return (
    <Host variant="secondary" as={as as any} {...rest}>
      <Content>
        {children}
        <FilterSvg />
      </Content>
    </Host>
  );
};
